import { render, staticRenderFns } from "./RedAsterisk.vue?vue&type=template&id=22fcdfc6&scoped=true&"
import script from "./RedAsterisk.vue?vue&type=script&lang=js&"
export * from "./RedAsterisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fcdfc6",
  null
  
)

export default component.exports